export default {
regis: `
  <p align="center">
    <strong>เงื่อนไขการสมัครสมาชิก</strong>
    <strong></strong>
</p>
<p>
1. ผู้สมัครยอมรับและตกลงปฏิบัติตามข้อตกลงและเงื่อนไขของ    <a href="http://www.goo-bank.com">www.goo-bank.com</a>
</p>
<p>
    2. ผู้สมัครต้องมีอายุตั้งแต่ 20 ปีบริบูรณ์ขึ้นไปตามข้อมูลในบัตรประชาชน
</p>
<p>
    3. ผู้สมัครต้องกรอกข้อมูลจริงเท่านั้น
หากทางระบบตรวจสอบแล้วข้อมูลเป็นเท็จทางระบบจะขอดำเนินการตามกฎของ    <a href="http://www.goo-bank.com">www.goo-bank.com</a>
</p>
<p>
    4.
    หากลูกค้ากรอกข้อมูลไม่ครบทางระบบขออนุญาตไม่อนุมัติการเป็นสมาชิกรบกวนลูกค้าทำการสมัครเข้ามาให้และกรอกข้อมูลให้ครบถ้วน
</p>
<p>
    5. เวลาให้บริการของ Goobank คือ 9.00น - 23.00น ของทุกวันหากทำรายการมาหลังช่วงเวลาที่กำหนดรายการของท่านจะถูกปฏิบัติในวันถัดไป
</p>
<p>
    6. การฝากเงินสามารถฝากได้ตั้งแต่เวลา 9.00น - 23.00น
    (หากทำรายการมานอกเวลาที่กล่าวไว้ข้างต้นระบบจะทำการตรวจสอบและทำรายการให้ในวันถัดไป)
</p>
<p>
    7. การถอนเงินสามารถถอนได้ตั้งแต่เวลา 9.00น – 23.00น
    (หากทำรายการมานอกเวลาที่กล่าวไว้ข้างต้นระบบจะทำการตรวจสอบและทำรายการให้ในวันถัดไป)
</p>
<p>
8. สิทธิประโยชน์ของบริการ    <a href="http://www.goo-bank.com">www.goo-bank.com</a>
    ขอสงวนไว้สำหรับสมาชิกเท่านั้น
</p>
<p>
    9. บริษัทฯ
    ขอสงวนสิทธิ์ในการยกเลิกหรือเปลี่ยนแปลงข้อมูลสมาชิกแต่เพียงผู้เดียวเท่านั้น
</p>
<p>
    10. บริษัทฯ
    ขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขและสิทธิประโยชน์โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
</p>
`,

// < br >
//     <p align="center">
//         <strong>เงื่อนไขการใช้งาน และนโยบายบริษัท</strong>
//     </p>
//     <p>
//         ทาง Goobank ขอแจ้งเงื่อนไขการใช้งาน
//         และนโยบายของบริษัทให้ผู้ใช้ทุกท่านเข้าใจตรงกันและได้ปฏิบัติตรงตามระเบียบของทางบริษัทได้กำหนดไว้ตามนี้ครับ
//         / ค่ะ
// </p>
  tos: `
<p>
    <strong>เงื่อนไขการใช้งาน</strong>
</p>
<p>
    1. ช่วงเวลาในการฝากเงินเข้าระบบคือ 9:00 น – 23:00 น ของทุกวัน
    (หากเวลาที่ผู้ใช้ทำเรื่องฝากเงินเข้ามาไม่ได้อยู่ในช่วงเวลาที่กำหนดยอดเงินจะเข้าระบบในวันถัดไป)
</p>
<p>
    2. ช่วงเวลาในการถอนเงินเข้าระบบคือ 9:00 น – 23:00 น ของทุกวัน
    (หากเวลาที่ผู้ใช้ทำเรื่องถอนเงินเข้ามาไม่ได้อยู่ในช่วงเวลาที่กำหนดทางระบบจะทำการโอนยอดเงินที่ให้ผู้ถอนในวันถัดไป)
</p>
<p>
    3. หากผู้ใช้ได้ทำแจ้งฝากเงินเข้ามาแต่
    แต่ไม่ได้ฝากเงินเข้ามาในระบบจริงหรือฝากเงินไม่ทันในเวลากำหนด
    (ระยะเวลาการฝากเงินคือ 30 นาที)
    ทางระบบขออนุญาตไม่โอนเงินเข้าระบบให้กับผู้ใช้
</p>
<p>
    4.
    หากผู้ใช้โอนเงินเข้ามาในระบบในเวลาที่กำหนดแล้วเงินไม่เข้าระบบของผู้ใช้ให้กดปุ่ม
    “แจ้งปัญหาการโอนเงิน” หรือ ปุ่ม “แจ้งปัญหาการใช้งาน”
    แล้วแจ้งข้อมูลการโอนเงิน 1. จำนวนยอดเงินที่โอนเงินเข้ามา 2.
    เวลาที่โอนเข้ามา 3. สลิปเงินโอน
    ทางระบบจะตรวจสอบข้อมูลและดำเนินการต่อตามความเหมาะสม
</p>
<p>
    5. ผู้ใช้สามารถสร้างสัญญาเงินกู้ และสัญญาซื้อ-ขายรวมกันภายใน 1
    วันได้ทั้งหมด 5 สัญญา
</p>
<p>
    6. อายุของสัญญาที่ส่งให้กับ “ผู้ให้กู้” หรือ “ผู้ขาย” มีอายุ 24 ช.ม. (หาก
    “ผู้ให้กู้” หรือ “ผู้ขาย”
    ไม่ตกลงทำสัญญาในเวลาที่กำหนดสัญญาฉบับนั้นถือว่าไม่เกิดขึ้น)
</p>
<p>
    7. “ผู้กู้” หรือ “ผู้ซื้อ” ต้องชำระค่างวดให้ตรงตามเวลาที่กำหนด
</p>
<p>
    8. หาก “ผู้กู้” หรือ “ผู้ซื้อ” ไม่ชำระค่างวดตามเวลาที่กำหนดสถานะของ
    “ผู้กู้” หรือ “ผู้ซื้อ” จะเปลี่ยนไปตามนี้
</p>
<p>
    8.1 ชำระล่าช้าภายใน 1-30 วัน สถานะ ปกติ (สีเขียว)
</p>
<p>
    8.2 ชำระล่าช้าภายใน 31-60 วัน สถานะ ไม่ปกติ (สีส้ม)
</p>
<p>
    8.3 ชำระล่าช้าภายใน 61-90 วัน สถานะ ไม่ปกติ (สีแดง)
</p>
<p>
    8.4 ชำระล่าช้าภายใน 90 วันขึ้นไป สถานะ ไม่ปกติ (สีดำ)
</p>
<p>
    หมายเหตุ : หาก “ผู้กู้” หรือ “ผู้ซื้อ” ไม่ชำระค่างวดตามเวลาที่กำหนด
    “ผู้ให้กู้” หรือ “ผู้ขาย”
    สามารถฟ้องร้องดำเนินคดีตามกฎหมายได้โดยที่ไม่ต้องแจ้ง “ผู้กู้” หรือ
    “ผู้ซื้อ” ล่วงหน้า
</p>
<p>
    9. การส่งสัญญาให้กับ “ผู้ให้กู้” หรือ “ผู้ขาย” มี 2 รูปแบบ คือ
</p>
<p>
    9.1 ส่งคำขอกู้เงิน (ธรรมดา)
</p>
<p>
    9.2 ส่งคำขอกู้เงินและประวัติเครดิต การส่งแบบนี้จะส่งข้อมูลสัญญาทั้งหมดที่
    “ผู้กู้” หรือ “ผู้ซื้อ” เคยทำให้กับ “ผู้ให้กู้” หรือ “ผู้ขาย”
    (การส่งแบบนี้จะแสดงสถานะของสัญญาทั้งหมดที่ผ่านมาของ “ผู้กู้” หรือ “ผู้ซื้อ”
    และมีค่าใช้จ่ายนะครับ / ค่ะ)
    เพื่อให้เพิ่มโอกาสการพิจารณาอนุมัติสัญญาให้มากขึ้น
</p>
<p>
    10. หากใช้งานแล้วเกิดปัญหาสามารถแจ้งข้อมูลได้ที่
    <br/>
    Facebook Fan Page :
    <a href="https://www.facebook.com/GoobankOfficial">
        https://www.facebook.com/GoobankOfficial
    </a>
</p>
<p>
    Line ID : @493wcjrw หรือ
    <a href="http://nav.cx/6vwdq35">
        http://nav.cx/6vwdq35
    </a>
</p>
<p>
    <strong>นโยบายของ Goobank</strong>
    <strong></strong>
</p>
<p>
    Goobank คือ อะไร
</p>
<p>
    เครื่องมือการทำธุรกรรมทางออนไลน์ชนิดหนึ่งที่จะมาช่วยให้คุณปลอดภัยขึ้น จาก
    การถูกยืมเงิน
</p>
<p>
    จากการขายสิ้นค้าแบบเงินผ่อน เป็นผู้ช่วยทางบัญชีให้คุณ
    ช่วยสร้างสัญญาเงินกู้ให้กับคุณ
    ช่วยทำสัญญาซื้อขายให้กับคุณแบบสะดวกและง่ายมาก
    สัญญาที่ถูกสร้างคุณยังสามารถบังคับใช้ทางกฎหมายได้เลย
    ช่วยคุณสร้างประวัติทางการเงินทางด้านการกู้-ยืม เงินระหว่างคน2 คน
    ช่วยคุณสร้างประวัติด้านการซื้อ-ขายสินค้าแบบเงินผ่อนระหว่างคน 2
    คนและทำให้คุณได้รับความเป็นธรรมในด้านดอกเบี้ยที่ถูกกฎหมาย ไม่เกินร้อยละ 15
    ต่อปี ระบบถูกออกแบบเผื่อรองรับบุคคลทั่วไปและนิติบุคคล
    เรามีระบบการรักษาข้อมูลลูกค้าที่รัดกุม
</p>
<p>
    <strong>
        <br/>
        <br/>
    </strong>
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong></strong>
</p>
<p>
    ทำไมต้อง Goobank
</p>
<p>
    สถาบันทางการเงินอื่นๆที่ปล่อยกู้ในอัตราดอกเบี้ยที่ควบคุมโดยกฎหมายที่มีดอกเบี้ยถูกเรามักพบว่า
    สถาบันเหล่านั้นมักให้มีสินทรัพย์ในการค้ำประกัน เช่น รถ ที่ดิน บ้านและอื่นๆ
    หรือในกรณี
    การกู้เงินนอกระบบแม้ไม่มีสินทรัพย์ค้ำประกันแต่ก็มีอัตราดอกเบี้ยมหาโหด
    ทั้งนี้เพื่อ เป็นการประกันความเสี่ยงในกรณีทีผู้กู้ไม่มีการชำระค่างวดตามตกลง
    ดังนั้นสิ่งที่กูแบงค์จะหยิบยื่นให้คือการเข้ามาช่วยเหลือผู้ที่กำลังทุกข์ร้อนและไม่มีสินทรัพย์ใดๆค้ำประกันความเสี่ยง
    เพียงคุณเป็นคนมีวินัยในการชำระค่างวดตามกำหนดเวลาที่ตกลงกัน ด้วยดอกเบี้ย
    0%-15% ต่อปี ซึ่งเป็นไปตามการควบคุมของกฎหมาย
    คุณก็สามารถทำธุรกรรมทางการเงินได้อย่างง่ายดายเพียงปลายนิ้ว
</p>
<p>
    Goobank มีประโยชน์สำหรับบุคคลธรรมดาในเรื่องการกู้ยืมเงินแบบทั่วไปอย่างไร
</p>
<p>
    เป็นแอพพิเคชั่นที่ช่วยในการประกอบการตัดสินใจในการให้คุณสามารถให้เพื่อนของคุณยืมเงินได้แบบลดความเสี่ยงมากว่าเดิม
    คุณสามารถที่เห็นประวัติการยืมเงินที่ผ่านมาของเพื่อนคุณที่จะมาขอกู้คุณได้
    ทำให้คุณตัดสินใจได้ง่ายขึ้น
</p>
<p>
    ข้อดีของ Goobank
</p>
<p>
    1. สามารถกู้ยืมเงินได้อย่างสะดวก
</p>
<p>
    2. มีข้อมูล ลูกหนี้-เจ้าหนี้ ชัดเจน ง่ายต่อการสืบค้น
</p>
<p>
    3. มีระบบการเตือนเพื่อช่วยเตือนความจำ ลดการใช้งานบุคลากร
    สามารถทำเองได้สะดวกมาก
</p>
<p>
    4. มีการคำนวณดอกเบี้ยแบบอัตโนมัติและเฉลี่ยตามเดือนได้อย่างแม่นยำ
</p>
<p>
    5. เป็นเครื่องเพิ่มรูปแบบการขายเพื่อขยายตลาดในวงกว้าง เพิ่มกำไร
    ขยายฐานธุรกิจ แบบผ่อนชำระได้
</p>
<p>
    6.
    มีสัญญาฉบับอิเล็กทรอนิคที่ใช้ในชั้นศาลได้ในรูปแบบกู้ยืมและสัญญาซื้อขายสินค้า
</p>
<p>
    7. ลดอัตราหนี้เสีย
</p>
<p>
    8. สามารถตรวจเช็คประวัติของผู้ขอกู้และผู้ขอซื้อสินค้าแบบผ่อนชำระเป็นงวดๆได้
</p>
<p>
    9. ระบบออกแบบมากำหนดดอกเบี้ยที่เป็นไปตามที่กฎหมายกำหนด ตั้งแต่ 0%-15% ต่อปี
</p>
<p>
    10. ไม่ต้องมีหลักทรัพย์ใดๆค้ำประกัน
</p>
<p>
    11. อนาคตจะมีแหล่งเงินกู้มากกว่า 100,000 คน
    ที่สนใจปล่อยกู้ในลักษณะนี้มากขึ้น
</p>
  `,
  fee: `<p align="center">
    <strong>ค่าธรรมเนียมต่างๆ ของ </strong>
    <strong>Goobank</strong>
</p>
<p>
    เนื่องจากการทำสัญญาทุกครั้งทางระบบมีค่าใช้จ่ายในการดำเนินการที่แตกต่างกันออกไปทาง
    Goobank จึงอยากขอแจ้งอัตราค่าบริการต่างๆ ให้ผู้ใช้ทุกท่านทราบตามนี้ครับ/ค่ะ
</p>
<p>
    1. ค่าธรรมเนียมการทำสัญญา (รวมทั้งสัญญาเงินกู้ และสัญญาซื้อขาย)
    อัตราค่าธรรมเนียมอยู่ที่ 1 % ของจำนวนเงินที่ทำสัญญา
</p>
<p>
    2. ค่าธรรมเนียมการถอนเงิน อัตราค่าธรรมเนียมอยู่ที่ 25 บาท ต่อ 1 รายการ
</p>
<p>
    3. ค่าธรรมเนียมประวัติเครดิตที่ส่งให้ “ผู้ให้กู้” หรือ “ผู้ขาย”
    อัตราค่าธรรมเนียมอยู่ที่ 30 บาท ต่อการส่ง 1 ครั้ง
</p>
<p>
    หมายเหตุ : 1.
    อัตราค่าธรรมเนียมการทำสัญญาของสัญญาซื้อขาจะคิดจากยอดที่หักออกจากเงินดาวน์แล้ว
</p>
<p>
    2. ทางบริษัท Goobank ขอสงวนสิทธิ์ในการปรับเปลี่ยนค่าธรรมเนียมต่างๆ
    โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
</p>`
}